import { makeRequest } from "../utils/apiUtils";
import { TOOL_ID_WIDGETS, SUBSCRIPTION_STATUS_ID_AVAILABLE } from 'cityads-v3/reducers/offers'

export const GO_FIRST_PAGE = "widgets/GO_FIRST_PAGE";
export const GO_NEXT_PAGE = "widgets/GO_NEXT_PAGE";
export const SET_CREATION_DATA = "widgets/SET_CREATION_DATA";
export const UPDATE_CREATION_DATA = "widgets/UPDATE_CREATION_DATA";

export const GET_WIDGETS = "widgets/GET_WIDGETS";
export const GET_WIDGETS_SUCCESS = "widgets/GET_WIDGETS_SUCCESS";
export const GET_WIDGETS_FAIL = "widgets/GET_WIDGETS_FAIL";

export const GET_TEMPLATES = "widgets/GET_TEMPLATES";
export const GET_TEMPLATES_SUCCESS = "widgets/GET_TEMPLATES_SUCCESS";
export const GET_TEMPLATES_FAIL = "widgets/GET_TEMPLATES_FAIL";

export const GET_TEMPLATES_BY_OFFER_ID = "widgets/GET_TEMPLATES_BY_OFFER_ID";
export const GET_TEMPLATES_BY_OFFER_ID_SUCCESS = "widgets/GET_TEMPLATES_BY_OFFER_ID_SUCCESS";
export const GET_TEMPLATES_BY_OFFER_ID_FAIL = "widgets/GET_TEMPLATES_BY_OFFER_ID_FAIL";

export const GET_TEMPLATE_BY_ID = "widgets/GET_TEMPLATE_BY_ID";
export const GET_TEMPLATE_BY_ID_SUCCESS = "widgets/GET_TEMPLATE_BY_ID_SUCCESS";
export const GET_TEMPLATE_BY_ID_FAIL = "widgets/GET_TEMPLATE_BY_ID_FAIL";

export const REMOVE_WIDGET = "widgets/REMOVE_WIDGET";
export const REMOVE_WIDGET_SUCCESS = "widgets/REMOVE_WIDGET_SUCCESS";
export const REMOVE_WIDGET_FAIL = "widgets/REMOVE_WIDGET_FAIL";

export const SAVE_WIDGET = "widgets/SAVE_WIDGET";
export const SAVE_WIDGET_SUCCESS = "widgets/SAVE_WIDGET_SUCCESS";
export const SAVE_WIDGET_FAIL = "widgets/SAVE_WIDGET_FAIL";

export const LOAD_WIDGET = "widgets/LOAD_WIDGET";
export const LOAD_WIDGET_SUCCESS = "widgets/LOAD_WIDGET_SUCCESS";
export const LOAD_WIDGET_FAIL = "widgets/LOAD_WIDGET_FAIL";

export const LOAD_WIDGET_OFFERS = "widgets/LOAD_WIDGET_OFFERS";
export const LOAD_WIDGET_OFFERS_SUCCESS = "widgets/LOAD_WIDGET_OFFERS_SUCCESS";
export const LOAD_WIDGET_OFFERS_FAIL = "widgets/LOAD_WIDGET_OFFERS_FAIL";

export function getWidgets() {
  return makeRequest('/saduka/widgets', {
    types: [GET_WIDGETS, GET_WIDGETS_SUCCESS, GET_WIDGETS_FAIL],
    options: {
      credentials: 'include'
    },
  });
}

export function getTemplates() {
  return makeRequest('/saduka/widgetTemplates', {
    types: [GET_TEMPLATES, GET_TEMPLATES_SUCCESS, GET_TEMPLATES_FAIL],
    options: {
      credentials: 'include'
    }
  })
}

export function getTemplatesByOfferId(offerId) {
  return makeRequest('/saduka/widgetTemplates?offer_id=' + offerId, {
    types: [GET_TEMPLATES_BY_OFFER_ID, GET_TEMPLATES_BY_OFFER_ID_SUCCESS, GET_TEMPLATES_BY_OFFER_ID_FAIL],
    options: {
      credentials: 'include'
    },
    offerId
  })
}

export function getTemplateById(id) {
  return makeRequest('/saduka/widgetTemplates/' + id, {
    types: [GET_TEMPLATE_BY_ID, GET_TEMPLATE_BY_ID_SUCCESS, GET_TEMPLATE_BY_ID_FAIL],
    options: {
      credentials: 'include'
    },
    id
  })
}

export function removeWidget(id) {
  return makeRequest('/saduka/widgets/' + id, {
    types: [REMOVE_WIDGET, REMOVE_WIDGET_SUCCESS, REMOVE_WIDGET_FAIL],
    options: {
      credentials: 'include',
      method: 'DELETE',
    },
    apiOptions: {
      toJson: false
    },
    id
  })
}

export function goFirstPage() {
  return {
    type: GO_FIRST_PAGE
  }
}

export function goNextPage(page = false) {
  return {
    type: GO_NEXT_PAGE,
    page
  }
}

export function setCreationData(data) {
  return {
    type: SET_CREATION_DATA,
    data
  }
}

export function updateCreationData(data) {
  return {
    type: UPDATE_CREATION_DATA,
    data
  }
}

export function saveWidget(data, id = 0) {
  return makeRequest('/saduka/widgets' + (id ? '/' + id : ''), {
    types: [SAVE_WIDGET, SAVE_WIDGET_SUCCESS, SAVE_WIDGET_FAIL],
    options: {
      credentials: 'include',
      method: id ? 'PATCH' : 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        widget: data
      })
    }
  })
}

export function loadWidget(id) {
  return makeRequest('/saduka/widgets/' + id, {
    types: [LOAD_WIDGET, LOAD_WIDGET_SUCCESS, LOAD_WIDGET_FAIL],
    options: {
      credentials: 'include',
    }
  })
}

export function loadWidgetOffers() {
  return makeRequest(`/saduka/offers?page=1&perpage=1000&subscription_status[]=${SUBSCRIPTION_STATUS_ID_AVAILABLE}&tool_id[]=${TOOL_ID_WIDGETS}`, {
    types: [LOAD_WIDGET_OFFERS, LOAD_WIDGET_OFFERS_SUCCESS, LOAD_WIDGET_OFFERS_FAIL],
    options: {
      credentials: 'include',
    }
  })
}
